module.exports = __webpack_public_path__ + "static/media/Facebook.a76e1953.svg";